import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class TextB extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M5.2,3.2H8c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.3s0.5,0.3,0.6,0.6c0.2,0.3,0.2,0.6,0.2,1c0,0.2,0,0.3-0.1,0.5
          c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.2,0.3-0.4,0.4S9.9,6.8,9.7,6.9v0c0.6,0.1,1,0.3,1.2,0.6c0.3,0.3,0.4,0.7,0.4,1.2
          c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-1,0.4C9.1,11,8.7,11,8.2,11h-3V3.2z M8,6.3c0.3,0,0.6-0.1,0.7-0.2
          c0.2-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.5C8.5,4.9,8.3,4.8,8,4.8H7.3v1.5H8z M8.1,9.5c0.8,0,1.2-0.3,1.2-0.9
          c0-0.3-0.1-0.5-0.3-0.6C8.8,7.8,8.5,7.8,8.1,7.8H7.3v1.7H8.1z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/TextB.js